import { Card } from 'layouts'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CurrentDateSlice } from 'redux/reducers'
import { getProjectDateRange, getStroage } from 'utils'
import './CurrentDate.scss'
import { DayNow } from './DayNow'
import { Select, Switch } from 'antd'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { t } from 'i18next'

export const CurrentDate = ({ projectData, setAwitchLengthOrArea, type, ConsumableDict, setConsumableDataId }) => {
    const dispatch = useDispatch()
    const [date, setDate] = useState()
    const language = getStroage('language')

    useEffect(() => {
        if (!projectData) return
        let { endDate } = getProjectDateRange(projectData, type)
        const today = moment().format('YYYY-MM-DD')
        let result = today
        if (today > endDate) result = endDate
        setDate(moment(result))
        if (type === 'hse') {
            dispatch(CurrentDateSlice.actions.addCurrentHSEDate(result))
        } else {
            dispatch(CurrentDateSlice.actions.addCurrentDate(result))
        }
        return () => {
            dispatch(CurrentDateSlice.actions.addCurrentDate(null))
            dispatch(CurrentDateSlice.actions.addCurrentHSEDate(null))
        }
    }, [projectData])

    /* 获取项目施工天数 */
    const getDaySurvey = () => {
        if (!projectData) return
        let { startDate, endDate } = getProjectDateRange(projectData, type)
        if (endDate) endDate = date > endDate ? endDate : date
        let diffDays = moment(endDate).diff(moment(startDate ?? new Date()), 'days') + 1
        if (diffDays < 0) diffDays = 0
        const daysString = moment(startDate).format('D MMM YYYY') + ' - ' + moment(endDate).format('D MMM YYYY')
        return { diffDays, daysString }
    }

    const onChange = checked => {
        setAwitchLengthOrArea(checked)
    }

    return (
        <Card className='currentDate'>
            <div className='days'>
                {type === 'consumable' ? (
                    <div className='title'>{t('nav.dashboard.children.ConsumableOverview')}</div>
                ) : (
                    <>
                        <div className='left'>{getDaySurvey()?.diffDays ?? 0}</div>
                        <div className='right'>
                            <div className='rightTop'>{getDaySurvey()?.diffDays ? 'Days' : ''}</div>
                            <div className='rightBottom'>{getDaySurvey()?.daysString}</div>
                        </div>
                    </>
                )}
            </div>
            <div className='DayNow'>
                {type === 'SourceStatisticsStreamer' ? (
                    <Switch
                        checkedChildren={language === 'en' ? 'Length' : '长度'}
                        unCheckedChildren={language === 'en' ? 'Area' : '面积'}
                        className='switch'
                        onChange={onChange}
                    />
                ) : (
                    <></>
                )}
                {type === 'consumable' ? (
                    ConsumableDict && (
                        <Select
                            onChange={(value, locationData) => {
                                setConsumableDataId(locationData?.value)
                            }}
                            className='consumable'
                            defaultValue={ConsumableDict?.[0]?.dictValue}
                            options={ConsumableDict?.map(item => ({
                                label: language === 'en' ? item.dictLabelEn : item.dictLabel,
                                value: item.dictValue,
                            }))}
                        />
                    )
                ) : (
                    <></>
                )}
                <ArrowLeftOutlined
                    className='ArrowLeftOutlined'
                    onClick={() => {
                        const { startDate } = getProjectDateRange(projectData, type)
                        let resultDate = moment(date).subtract(1, 'days').format('YYYY-MM-DD')
                        if (resultDate < startDate) resultDate = startDate
                        setDate(moment(resultDate))
                        if (type === 'hse') {
                            dispatch(CurrentDateSlice.actions.addCurrentHSEDate(resultDate))
                        } else {
                            dispatch(CurrentDateSlice.actions.addCurrentDate(resultDate))
                        }
                    }}
                />
                <ArrowRightOutlined
                    className='ArrowRightOutlined'
                    onClick={() => {
                        const { endDate } = getProjectDateRange(projectData, type)
                        let resultDate = moment(date).add(1, 'days').format('YYYY-MM-DD')
                        if (resultDate > endDate) resultDate = endDate
                        setDate(moment(resultDate))
                        if (type === 'hse') {
                            dispatch(CurrentDateSlice.actions.addCurrentHSEDate(resultDate))
                        } else {
                            dispatch(CurrentDateSlice.actions.addCurrentDate(resultDate))
                        }
                    }}
                />
                <DayNow projectData={projectData} setDate={setDate} date={date} type={type} />
            </div>
        </Card>
    )
}
